import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MobileContext } from "../../providers/MobileContext";
import styles from "./PartnerHomePage.module.scss";
import ScrollTopButton from "../../Components/Button/ScrollTopButton";
import Layout from "../../Components/Layout/Layout";
import Search from "../../Components/Search/Search";
import Wrapper from "../../Components/Layout/Wrapper";
import ContactWrapper from "../../Components/ContactWrapper/ContactWrapper";
import Popup from "../../Components/Popup/Popup";
import GoogleMap from "../../Components/GoogleMap/GoogleMap";
import BasicAPI from "../../API/BasicAPI";
import Youtube from "../../Components/Youtube/Youtube";
import CustomPagination from "../../Components/Pagination/CustomPagination";
import Gallery from "../../Components/Gallery/Gallery";

/* swiper */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

/* images */
import locationIcon from "../../Assets/Images/view_map_clicked.png";
import defaultImage from "../../Assets/Images/logo01.png";

const PartnerHomePage = () => {
  const { id } = useParams();
  const isMobile = useContext(MobileContext);

  const [partnerInfo, setPartnerInfo] = useState("");
  const [youtubeChannelInfo, setYoutubeChannelInfo] = useState("");
  const [youtubeMainVideo, setYoutubeMainVideo] = useState("");
  const [youtubeVideoList, setYoutubeVideoList] = useState("");
  const [popupOpened, setPopupOpened] = useState(false);
  const [galleryOpened, setGalleryOpened] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [newArticleList, setNewArticleList] = useState([]);
  const [newGalleryList, setNewGalleryList] = useState([]);
  const [articlePageNum, setArticlePageNum] = useState(1);
  const [galleryPageNum, setGalleryPageNum] = useState(1);

  const openGalleryPopup = (index) => {
    let tempNum;

    isMobile
      ? (tempNum = 2 * galleryPageNum - 2)
      : (tempNum = 12 * (galleryPageNum - 1));

    galleryPageNum < 2
      ? setSelectedImg(index)
      : setSelectedImg(tempNum + index);

    setGalleryOpened(true);
    document.documentElement.style.overflow = "hidden";
  };

  useEffect(() => {
    BasicAPI({
      url: `${process.env.REACT_APP_SERVICE_URL}/partner/partners/${id}`,
      success: (res) => setPartnerInfo(res.data),
      fail: (res) => console.error(res),
    });
  }, []);

  useEffect(() => {
    if (!partnerInfo) return;

    const itemPerView = isMobile ? 2 : 9;
    const startIndex = (articlePageNum - 1) * itemPerView;
    const endIndex = articlePageNum * itemPerView;

    let newList = [];

    for (
      let i = startIndex;
      i < endIndex && i < partnerInfo.article.item_list.length;
      i++
    ) {
      newList.push(partnerInfo.article.item_list[i]);
    }

    setNewArticleList(newList);
  }, [partnerInfo, articlePageNum, isMobile]);

  useEffect(() => {
    if (!partnerInfo) return;

    const itemPerView = isMobile ? 2 : 12;
    const startIndex = (galleryPageNum - 1) * itemPerView;
    const endIndex = galleryPageNum * itemPerView;

    let newList = [];

    for (
      let i = startIndex;
      i < endIndex && i < partnerInfo.gallery.item_list.length;
      i++
    ) {
      newList.push(partnerInfo.gallery.item_list[i]);
    }

    setNewGalleryList(newList);
  }, [partnerInfo, galleryPageNum, isMobile]);
  /* 
  useEffect(() => {
    if (
      partnerInfo === "" ||
      !partnerInfo.youtube ||
      partnerInfo.youtube === ""
    )
      return;

    //채널정보 호출
    BasicAPI({
      url: "https://www.googleapis.com/youtube/v3/channels",
      method: "GET",
      data: {
        id: partnerInfo.youtube.user_id,
        key: process.env.REACT_APP_GOOGLE_KEY,
        part: "snippet, statistics",
        fields:
          "items(snippet(title, description, customUrl, thumbnails(high(url))), statistics(viewCount, subscriberCount, videoCount))",
      },
      success: (res) => setYoutubeChannelInfo(res.items[0]),
      fail: (res) => console.error(res),
    });

    //최신영상 호출
    BasicAPI({
      url: "https://www.googleapis.com/youtube/v3/search",
      method: "GET",
      data: {
        channelId: partnerInfo.youtube.user_id,
        key: process.env.REACT_APP_GOOGLE_KEY,
        part: "snippet",
        order: "date",
        maxResults: 6,
      },
      success: (res) => setYoutubeVideoList(res.items),
      fail: (res) => console.error(res),
    });

    //메인영상 호출
    //메인영상이 지정되지 않은 경우 조회수가 가장 높은 영상 호출
    if (!partnerInfo.youtube.main_video_url) {
      BasicAPI({
        url: "https://www.googleapis.com/youtube/v3/search",
        method: "GET",
        data: {
          channelId: partnerInfo.youtube.user_id,
          key: process.env.REACT_APP_GOOGLE_KEY,
          part: "snippet",
          order: "viewCount",
          maxResults: 1,
        },
        success: (res) => setYoutubeMainVideo(res.items[0]),
        fail: (res) => console.error(res),
      });
    } else {
      BasicAPI({
        url: "https://www.googleapis.com/youtube/v3/videos",
        method: "GET",
        data: {
          id: partnerInfo.youtube.main_video_url,
          key: process.env.REACT_APP_GOOGLE_KEY,
          part: "snippet",
        },
        success: (res) => setYoutubeMainVideo(res.items[0]),
        fail: (res) => console.error(res),
      });
    }
  }, [partnerInfo]); */

  return (
    <Layout>
      <Search />
      {partnerInfo && (
        <div className={styles.content_wrapper}>
          <div className={styles.top_container}>
            <Wrapper>
              <div
                className={styles.info_wrapper}
                style={{ flexDirection: isMobile ? "column" : "row" }}
              >
                <div className={styles.thumbnail_wrapper}>
                  {partnerInfo.thumbnail ? (
                    <img src={partnerInfo.thumbnail} alt="썸네일" />
                  ) : (
                    <img
                      src={defaultImage}
                      className={styles.default_img}
                      alt="기본 이미지"
                    />
                  )}
                </div>
                <div className={styles.text_wrapper}>
                  <div
                    className={styles.title}
                    style={{ paddingTop: isMobile ? "4rem" : "0" }}
                  >
                    {partnerInfo.company_name}
                  </div>
                  <div className={styles.location}>
                    <img src={locationIcon} alt="병원 위치" />
                    <p>{partnerInfo.addr}</p>
                  </div>
                  <ContactWrapper
                    partnerInfo={partnerInfo}
                    snsGap={1.5}
                    iconSize={4}
                    setPopupOpened={setPopupOpened}
                  />
                </div>
              </div>
              {partnerInfo.ad_banner.item_list.length !== 0 && (
                <Swiper
                  className={styles.banner}
                  modules={[Autoplay, Pagination]}
                  slidesPerView={1}
                  loop
                  autoplay={{ delay: 3000 }}
                  pagination
                >
                  {partnerInfo.ad_banner.item_list.map((banner) => (
                    <SwiperSlide key={banner.id}>
                      <img src={banner.file} alt="광고 배너" />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </Wrapper>
          </div>
          <div className={styles.main_content_wrapper}>
            <Wrapper>
              {partnerInfo.intro && partnerInfo.sns && (
                <div className={styles.content}>
                  <div className={styles.title}>Intro</div>
                  <div className={styles.text}>
                    {partnerInfo.intro.description}
                  </div>
                  <GoogleMap
                    locations={[partnerInfo]}
                    mapsize={50}
                    zoom={18}
                    margin={[3, 0, 0, 0]}
                  />
                </div>
              )}
              {partnerInfo.description && (
                <div className={styles.content}>
                  <div className={styles.title}>About</div>
                  <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{
                      __html: partnerInfo.description,
                    }}
                  ></div>
                </div>
              )}
              {youtubeChannelInfo && youtubeVideoList && (
                <div className={styles.content}>
                  <div className={styles.title}>Youtube</div>
                  <Youtube
                    channelInfo={youtubeChannelInfo}
                    mainVideo={youtubeMainVideo}
                    videoList={youtubeVideoList}
                  />
                </div>
              )}
              {partnerInfo.article.item_list.length !== 0 && (
                <div className={styles.content}>
                  <div className={styles.title}>Article</div>
                  <div
                    className={styles.article_wrapper}
                    style={{
                      gridTemplateColumns: isMobile
                        ? "unset"
                        : "repeat(3, 1fr)",
                    }}
                  >
                    {newArticleList.map((article, index) => (
                      <Link
                        to={`/article/articles/${article.id}`}
                        className={styles.article}
                        key={index}
                      >
                        <div className={styles.thumbnail_wrapper}>
                          {article.thumbnail ? (
                            <img src={article.thumbnail} alt="기사 이미지" />
                          ) : (
                            <img
                              src={defaultImage}
                              className={styles.default_img}
                              alt="기본 이미지"
                            />
                          )}
                        </div>
                        <div className={styles.article_title}>
                          {article.title}
                        </div>
                        <div className={styles.article_date}>
                          {article.date}
                        </div>
                      </Link>
                    ))}
                  </div>
                  <CustomPagination
                    totalItemNum={
                      partnerInfo.article.total_length > 30
                        ? 30
                        : partnerInfo.article.total_length
                    }
                    itemsCountPerPage={isMobile ? 2 : 9}
                    padding={"3rem 0 0 0"}
                    setPageNum={setArticlePageNum}
                  />
                </div>
              )}
              {partnerInfo.gallery.item_list.length !== 0 && (
                <div className={styles.content}>
                  <div className={styles.title}>Gallery</div>
                  <div
                    className={styles.gallery_wrapper}
                    style={{
                      gridTemplateColumns: isMobile
                        ? "unset"
                        : "repeat(3, 1fr)",
                    }}
                  >
                    {newGalleryList.map((img, index) => (
                      <div
                        className={styles.img_wrapper}
                        onClick={() => openGalleryPopup(index)}
                        key={img.id}
                      >
                        <img
                          src={img.original}
                          alt="갤러리 이미지"
                          id={img.id}
                        />
                      </div>
                    ))}
                  </div>
                  <CustomPagination
                    totalItemNum={
                      partnerInfo.gallery.total_length > 30
                        ? 30
                        : partnerInfo.gallery.total_length
                    }
                    itemsCountPerPage={isMobile ? 2 : 12}
                    padding={"3rem 0 0 0"}
                    setPageNum={setGalleryPageNum}
                  />
                </div>
              )}
            </Wrapper>
          </div>
        </div>
      )}
      {popupOpened && <Popup setPopupOpened={setPopupOpened} />}
      {galleryOpened && (
        <Gallery
          imgList={partnerInfo.gallery.item_list}
          setGalleryOpened={setGalleryOpened}
          startIndex={selectedImg}
        />
      )}
      <ScrollTopButton />
    </Layout>
  );
};

export default PartnerHomePage;
